import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

interface IDot {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  intensity: number;
}

const Dot = (props: IDot) => {
  const { onMouseEnter, onMouseLeave, intensity } = props;

  const normalizeIntensity = (intensity: number): number => {
    if (intensity < 0) return 0;
    if (intensity > 10) return 10;
    return Math.ceil(intensity);
  };

  if (!intensity) return null;
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classnames(
        styles.dot,
        styles[`craving-${normalizeIntensity(intensity)}` || ''],
      )}
    >
      <div
        className={styles['text-hidden']}
      >{`Craving of intensity ${intensity}`}</div>
    </div>
  );
};

export default Dot;
